import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

import { GlobalVariable } from '../global';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.page.html',
  styleUrls: ['./checkout.page.scss'],
})
export class CheckoutPage implements OnInit {
  deliveryAddress: Object[] = [];
  activePaymentMedthod:any;
  constructor( public alertcontroller:AlertController,
     private router:Router,
 
     private global:GlobalVariable
     ) { }

  ngOnInit() {
  }
  ionViewWillEnter(){

    this.activePaymentMedthod=this.global.paymentMethod;
    console.log( this.activePaymentMedthod);

    // this.getdeliveryAdress();
    console.log('checkout page entered')
  }
  // getdeliveryAdress(){
  //   this.storage.get('DeliveryAddress').then(res=>{
  //         if(res!=null){
  //           this.deliveryAddress=res;
  //         }
  //         else{
  //           this.deliveryAddress=[];
  //         }

  //   })
  // }
  // async placeOrder(){
   
  //   // send orders data to restaurants... and then
  //   let recentOrders=this.storage.get('cartItems')
  //   this.storage.set('recentOrders',recentOrders);
  //   // clear cart items after order placed.
  //   this.storage.set('cartItems',[]);
  //  this.global.alertSimple('Success',"Your Order is Placed. We'll send you message with more details","OK");
  //   this.router.navigate(['/tabs/tabs/home']);
  // }
}
